import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Estimator } from '../../ship/models/estimator.model';

@Component({
  selector: 'upsc-ship-service-estimate',
  templateUrl: './ship-service-estimate.component.html',
  styleUrls: ['./ship-service-estimate.component.scss'],
})
export class ShipServiceEstimateComponent implements OnInit {
  @Input() estimator: Estimator;
  @Output() estimateChanged: EventEmitter<Estimator> = new EventEmitter<Estimator>();
  @Input() customerServices: any[];
  @Input() insuredValue: any;

  public isInsuredAmountExceeded = false;

  constructor() {

  }

  public ngOnInit() {
    this.checkInsuredAmount();
  }

  public checkInsuredAmount() {    
    const maxCoverage = this.customerServices.filter(x => x.ServiceCode == this.estimator.ServiceCode)[0].MaxCoverage;
    if (this.insuredValue && this.insuredValue > maxCoverage)
      this.isInsuredAmountExceeded = true;
    else this.isInsuredAmountExceeded = false;
  }

  public shipNow(event) {
    event.preventDefault();

    this.estimateChanged.emit(this.estimator);
  }
}
